import { Trans, useLingui } from '@lingui/react/macro'
import { ButtonFilled } from '@vgw/multibrand-fe-button'
import { AppLogo } from '@/features/header/app-logo'
import { Link as MultibrandLink } from '@vgw/multibrand-fe-link'
import { getBrandConfig } from '@/config/config'
import { Link, useNavigate } from '@tanstack/react-router'
import { Layout } from '@/layout/layout'
import { Content } from '@/layout/content'
import { Footer } from '@/features/footer/footer'
import { getBrandAssetsConfig } from '@/config/assets-config'

export const Page404 = () => {
  const { t } = useLingui()
  const { name } = getBrandConfig()
  const { page404 } = getBrandAssetsConfig()
  const navigate = useNavigate()

  return (
    <Layout>
      <Content backgroundVariant="branded">
        <div
          className="mx-auto flex max-w-lg flex-1 flex-col items-center justify-center gap-10 px-2 py-10 sm:px-4 lg:px-6"
          data-testid="page-404"
        >
          <div className="flex flex-col justify-center">
            <MultibrandLink asChild>
              <Link
                to="/"
                title={t`Go to VGW ${name} Homepage`}
                aria-label={t`Go to VGW ${name} Homepage`}
              >
                <AppLogo />
              </Link>
            </MultibrandLink>
          </div>
          <div className="flex grow flex-col items-center gap-4">
            <img srcSet={page404} width={194} height={90} alt="" aria-hidden />
            <div className="flex flex-col items-center gap-3 text-center text-content">
              <h1 className="font-family-display text-2xl leading-9 font-bold tracking-normal">
                <Trans>Page Not Found</Trans>
              </h1>
              <p className="font-family-body text-lg leading-7 font-light tracking-normal">
                <Trans>
                  We couldn&apos;t find the page you were looking for.
                </Trans>
              </p>
              <ButtonFilled onClick={() => navigate({ to: '/' })} size="lg">
                <Trans>Go home</Trans>
              </ButtonFilled>
            </div>
          </div>
        </div>
      </Content>
      <Footer />
    </Layout>
  )
}
